import { BrowserRouter, Route, Routes } from "react-router-dom";
import Login from "../login/Login";
import Registration from "../Registration/Signup";
import AddressForm from "../forms/AddressForm";
import Chat from "../chat/Chat";
import Myqoutes from "../myqoutes/Myqoutes";
import NewQoutes from "../newqoutes/NewQoutes";
import TrackShipment from "../trackshipment/TrackShipment";
import ShipmentHistory from "../shipmenthistory/ShipmentHistory";
import Dashboard from "../dashboard";
import Shipments from "../shipments";
import Profile from "../Profile";
import OrderHistory from "../orderHistory";
import Clients from "../clients";
import Settings from "../settings";
import Admins from "../admins";
import Quotes from "../quote";
import Quoteadmin from "../quoteadmin/Quoteadmin";
import Quoteadmindetails from "../quoteadmindetails/Quoteadmindetails";
import UserHeader from "../users/UserHeader";
import User from "../users/User";
import CreateQoute from "../create-quote/AddressForm";
import Calculator from "../iorCalculator";
import CreateShipment from "../create-shipment";
import MyWarehouse from "../../myWarehoue";
import EditShipment from "../shipments/edit";
import Tracking from "../trackshipment/tracking";
import EditQuotesForm from "../forms/editQuoteForm";
import TrackingLink from "../trackingLink";
import ViewQuote from "../forms/viewQuote";
import MyShipment from "../myShipments";
import NewRequest from "../newRequest";
import EditRequest from "../newRequest/editRequest";
import AddQuotesFromRequest from "../forms/addQuoteFromRequest";
import AddUserForm from "../admins/addUser";
import CreateTicket from "../support/CreateTicket";
import TicketDetails from "../support/TicketDetails";
import SupportTickets from "../support";
import UserRegistration from "../userRegistration";
import ToDo from "../todo";
import Invoices from "../Invoices";
import Signup from "../Registration/Signup";
import PrivateRoute from "./protectecRoute";
import NewRequestsList from "../forms/NewRequest";
import ForgotPassword from '../../components/forgotPassword/ForgotPassword';
import ResetPassword from '../../components/resetPassword/ResetPassword';
import EditRequestForm from "../forms/editRequestForm";
import ResetInvoicePassword from '../../components/Invoices/ResetPasswordComponent';
import UpdateIORFormAdmin from "../forms/updateIORFormadmin";
import EstimatedIOR from "../forms/estimatedIOR";
import CompleteEstimationForm from "../forms/CompleteEstimationForm";
import EditIORForm from "../settings/editIORForm";
import IORSettingsTable from "../settings/iorSettingsTable";
import NewQuoteRequestForm from "../forms/NewQuoteRequestForm";
import ExternalLinkPage from "../../components/externalEstimateURL/ExternalLinkPage";
import IorOusCalculatorPage from "../../components/iorOusCalculator/IorOusCalculatorPage"; // New import
import PageNotFound from "../PageNotFound";
import IorCalculatorPage from "../iorCalculatorNew/IorCalculatorPage";
import AiHsCalculatorPage from "../aiHsCalculator/AiHsCalculatorPage";
import IorCalculatorPageAdmin from "../iorCalculatorAdmin/IorCalculatorPageAdmin";
import VerifyOtp from "../verify-otp/VerifyOtp";
import Tutorials from "../tutorials";

const routes = [
  {
    //public routes
    type: "Public", children: [
      { path: "*", element: <PageNotFound /> },
      { path: "/", element: <Login /> },
      { path: "/Signup", element: <Signup /> },
      { path: "/forgot-password", element: <ForgotPassword /> },
      { path: "/verify-otp", element: <VerifyOtp /> },
      { path: "/reset-password", element: <ResetPassword /> },
      { path: "/trackshipment/:id", element: <TrackingLink /> },
      { path: "/invoice-password-reset/:token", element: <ResetInvoicePassword /> },
      { path: "/guest-estimate/:linkId/:subpage?", element: <ExternalLinkPage /> },
      { path: "/ior-ous-calculator/:linkId/:subpage?", element: <IorOusCalculatorPage /> },
    ]
  },
  {
    //private routes
    type: "Private", children: [
      // { path: "/user", element: <AddUserForm /> },
      // { path: "/create-ior", element: <UpdateIORFormAdmin />, allowedRoles: ['super admin', 'managing admin', 'lead admin', 'editor'] },
      { path: "/ior-settings", element: <IORSettingsTable />, allowedRoles: ['super admin', 'managing admin', 'lead admin', 'editor'] },
      { path: "/edit-ior/:estimateId", element: <EditIORForm />, allowedRoles: ['super admin', 'managing admin', 'lead admin', 'editor'] },
      { path: "/user-registration", element: <UserRegistration />, allowedRoles: ['super admin', 'managing admin', 'lead admin', 'editor'] },
      { path: "/todo", element: <ToDo />, allowedRoles: ['super admin', 'managing admin', 'lead admin', 'editor'] },
      { path: "/dashboard", element: <Dashboard />, allowedRoles: ['super admin', 'managing admin', 'lead admin', 'editor', 'user'] },
      { path: "/support&help", element: <Chat />, allowedRoles: ['super admin', 'managing admin', 'lead admin', 'editor', 'user'] },
      { path: "/tutorials", element: <Tutorials />, allowedRoles: ['user'] },
      { path: "/tickets/create", element: <CreateTicket />, allowedRoles: ['super admin', 'managing admin', 'lead admin', 'editor', 'user'] },
      { path: "/tickets/:id", element: <TicketDetails />, allowedRoles: ['super admin', 'managing admin', 'lead admin', 'editor', 'user'] },
      { path: "/tickets", element: <SupportTickets />, allowedRoles: ['super admin', 'managing admin', 'lead admin', 'editor', 'user'] },
      { path: "/profile", element: <Profile />, allowedRoles: ['super admin', 'managing admin', 'lead admin', 'editor', 'user'] },
      { path: "/shipments", element: <Shipments />, allowedRoles: ['super admin', 'managing admin', 'lead admin', 'editor'] },
      { path: "/shipments/:id", element: <EditShipment />, allowedRoles: ['super admin', 'managing admin', 'lead admin', 'editor'] },
      { path: "/orderhistory", element: <OrderHistory />, allowedRoles: ['super admin', 'managing admin', 'lead admin', 'editor', 'user'] },
      { path: "/admins", element: <Admins />, allowedRoles: ['super admin', 'managing admin', 'lead admin', 'editor'] },
      { path: "/invoices", element: <Invoices />, allowedRoles: ['super admin', 'managing admin', 'lead admin', 'editor', 'user'] },
      { path: "/clients", element: <User />, allowedRoles: ['super admin', 'managing admin', 'lead admin', 'editor'] },
      { path: "/quotes", element: <Quotes />, allowedRoles: ['super admin', 'managing admin', 'lead admin', 'editor', 'user'] },
      { path: "/newRequest", element: <NewRequest />, allowedRoles: ['super admin', 'managing admin', 'lead admin', 'editor', 'user'] },
      { path: "/editRequest/:id", element: <EditRequest />, allowedRoles: ['super admin', 'managing admin', 'lead admin', 'editor', 'user'] },
      { path: "/addQuoteFromRequest/:id", element: <AddQuotesFromRequest />, allowedRoles: ['super admin', 'managing admin', 'lead admin', 'editor', 'user'] },
      { path: "/editQuotes/:id", element: <EditQuotesForm />, allowedRoles: ['super admin', 'managing admin', 'lead admin', 'editor', 'user'] },
      { path: "/viewQuote/:id", element: <ViewQuote />, allowedRoles: ['super admin', 'managing admin', 'lead admin', 'editor', 'user'] },
      { path: "/settings", element: <Settings />, allowedRoles: ['super admin', 'managing admin', 'lead admin', 'editor'] },
      { path: "/bookshipment", element: <NewRequestsList />, allowedRoles: ['super admin', 'managing admin', 'lead admin', 'editor', 'user'] },
      { path: "/new-quote-request", element: <NewQuoteRequestForm />, allowedRoles: ['super admin', 'managing admin', 'lead admin', 'editor', 'user'] },
      { path: "/estimate/new", element: <NewRequestsList />, allowedRoles: ['super admin', 'managing admin', 'lead admin', 'editor', 'user'] },
      { path: "/estimate/:id", element: <NewRequestsList />, allowedRoles: ['super admin', 'managing admin', 'lead admin', 'editor', 'user'] },
      { path: "/trackshipment", element: <Tracking />, allowedRoles: ['super admin', 'managing admin', 'lead admin', 'editor', 'user'] },
      { path: "/shipmenthistory", element: <ShipmentHistory />, allowedRoles: ['super admin', 'managing admin', 'lead admin', 'editor', 'user'] },
      { path: "/newquotes", element: <NewQoutes />, allowedRoles: ['super admin', 'managing admin', 'lead admin', 'editor', 'user'] },
      { path: "/quoteadmin", element: <Quoteadmin />, allowedRoles: ['super admin', 'managing admin', 'lead admin', 'editor'] },
      { path: "/quoteadmindetails", element: <Quoteadmindetails />, allowedRoles: ['super admin', 'managing admin', 'lead admin', 'editor', 'user'] },
      { path: "/ior-calculator", element: <Calculator />, allowedRoles: ['super admin', 'managing admin', 'lead admin', 'editor', 'user'] },
      { path: "/oneunion-trade-os", element: <IorCalculatorPage />, allowedRoles: ['super admin', 'managing admin', 'lead admin', 'editor', 'user'] },
      { path: "/hs-compass", element: <AiHsCalculatorPage />, allowedRoles: ['super admin', 'managing admin', 'lead admin', 'editor', 'user'] },

      { path: "/admin-oneunion-trade-os", element: <IorCalculatorPageAdmin />, allowedRoles: ["super admin", "managing admin", "lead admin", "editor"], },

      { path: "/shipment/my-warehouse", element: <MyWarehouse />, allowedRoles: ['super admin', 'managing admin', 'lead admin', 'editor', 'user'] },
      { path: "/shipments/create-shipment", element: <CreateShipment />, allowedRoles: ['super admin', 'managing admin', 'lead admin', 'editor', 'user'] },
      { path: "/update-ior-admin", element: <UpdateIORFormAdmin />, allowedRoles: ['super admin'] },
      { path: "/myqoutes", element: <Myqoutes />, allowedRoles: ['super admin', 'managing admin', 'lead admin', 'editor', 'user'] },
      { path: "/myqoutes/create-quote", element: <CreateQoute />, allowedRoles: ['super admin', 'managing admin', 'lead admin', 'editor', 'user'] },
      { path: "/myShipment", element: <MyShipment />, allowedRoles: ['super admin', 'managing admin', 'lead admin', 'editor', 'user'] },
      { path: "/editRequestForm/:id", element: <EditRequestForm />, allowedRoles: ['super admin', 'managing admin', 'lead admin', 'editor', 'user'] },
      { path: "/estimated-ior/:estimateId", element: <EstimatedIOR />, allowedRoles: ['super admin', 'managing admin', 'lead admin', 'editor'] },
      { path: "/complete-estimation/:estimateId", element: <CompleteEstimationForm />, allowedRoles: ['super admin', 'managing admin', 'lead admin', 'editor'] },
    ]
  },
]

function Routing() {
  return (
    <>
      <Routes>
        {routes.map((route, idx) =>
          route.type === "Public" ? (
            route.children.map((childRoute, cidx) => (
              <Route
                key={cidx}
                path={childRoute.path}
                element={childRoute.element}
              />
            ))
          ) : (
            route.children.map((childRoute, cidx) => (
              <Route
                key={cidx}
                path={childRoute.path}
                element={
                  <PrivateRoute allowedRoles={childRoute.allowedRoles}>
                    {childRoute.element}
                  </PrivateRoute>
                }
              />
            ))
          )
        )}
      </Routes>

    </>
  );
}

export default Routing;
